{
  "familyId": "TAA-ONT-GEZEGDE",
  "questions": [
    {
      "id": "TAA-ONT-GEZEGDE-001",
      "familyId": "TAA-ONT-GEZEGDE",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_gezegde",
      "questionType": "multiple_choice",
      "question": "Wat is het gezegde in de zin: 'De kat slaapt op de bank.'?",
      "options": ["slaapt", "De kat", "op de bank", "De kat slaapt"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Gezegde vinden", "content": "Het gezegde vertelt wat het onderwerp doet of is. Het bevat altijd de persoonsvorm. Zoek eerst de persoonsvorm (verander de tijd van de zin).", "icon": "lightbulb"}}],
      "conceptId": "gezegde_enkelvoudig",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.80,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "taa.gez-onderwerp-als-gezegde", "label": "Onderwerp aangemerkt als gezegde", "optionIndex": 1 },
          { "id": "taa.gez-bwb-als-gezegde", "label": "Bijwoordelijke bepaling aangemerkt als gezegde", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "Het gezegde is 'slaapt'. Het gezegde vertelt wat het onderwerp doet of is. De kat doet iets: slapen. Het gezegde bevat altijd de persoonsvorm.",
        "solutionSteps": [
          "Zoek de persoonsvorm: verander de tijd → 'De kat sliep' → slaapt verandert, dus slaapt = PV",
          "Het gezegde bevat de persoonsvorm",
          "In deze zin is het gezegde alleen de PV: 'slaapt'"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Slaapt' is het gezegde — het vertelt wat de kat doet.",
          "1": "Je dacht waarschijnlijk dat 'De kat' het gezegde is. Maar 'De kat' is het onderwerp (wie slaapt?), niet het gezegde. Onthoud: het gezegde vertelt wat het onderwerp doet.",
          "2": "Je dacht waarschijnlijk dat 'op de bank' het gezegde is. Maar 'op de bank' is een bijwoordelijke bepaling van plaats (waar slaapt de kat?). Onthoud: het gezegde bevat de persoonsvorm.",
          "3": "Je dacht waarschijnlijk dat 'De kat slaapt' het gezegde is. Maar 'De kat slaapt' bevat zowel het onderwerp als het gezegde. Het gezegde alleen is 'slaapt'."
        }
      }
    },
    {
      "id": "TAA-ONT-GEZEGDE-002",
      "familyId": "TAA-ONT-GEZEGDE",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_gezegde",
      "questionType": "multiple_choice",
      "question": "Wat is het gezegde in de zin: 'Mijn broer heeft een nieuwe fiets gekocht.'?",
      "options": ["heeft gekocht", "Mijn broer", "een nieuwe fiets", "gekocht"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Samengesteld gezegde", "content": "Een samengesteld gezegde bevat meerdere werkwoorden: de persoonsvorm + andere werkwoorden. Voorbeeld: 'heeft gekocht' = PV 'heeft' + voltooid deelwoord 'gekocht'.", "icon": "lightbulb"}}],
      "conceptId": "gezegde_samengesteld",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.77,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.gez-lv-als-gezegde", "label": "Lijdend voorwerp aangemerkt als gezegde", "optionIndex": 2 },
          { "id": "taa.gez-alleen-vd", "label": "Alleen voltooid deelwoord als gezegde", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Het gezegde is 'heeft gekocht'. Dit is een samengesteld gezegde: de persoonsvorm 'heeft' + het voltooid deelwoord 'gekocht'. Samen vertellen ze wat het onderwerp heeft gedaan.",
        "solutionSteps": [
          "Zoek de persoonsvorm: 'heeft' (verandert bij tijdwisseling)",
          "Zoek andere werkwoorden: 'gekocht' (voltooid deelwoord)",
          "Het gezegde = alle werkwoorden samen: 'heeft gekocht'"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Heeft gekocht' is het volledige gezegde (PV + voltooid deelwoord).",
          "1": "Je dacht waarschijnlijk dat 'Mijn broer' het gezegde is. Maar 'Mijn broer' is het onderwerp (wie heeft gekocht?). Onthoud: het gezegde bevat de werkwoorden.",
          "2": "Je dacht waarschijnlijk dat 'een nieuwe fiets' het gezegde is. Maar 'een nieuwe fiets' is het lijdend voorwerp (wat heeft hij gekocht?). Onthoud: het gezegde vertelt wat er gebeurt.",
          "3": "Je dacht waarschijnlijk dat alleen 'gekocht' het gezegde is. Maar 'gekocht' is maar een deel — je hebt ook 'heeft' nodig: 'heeft gekocht'. Onthoud: het gezegde bevat alle werkwoorden."
        }
      }
    },
    {
      "id": "TAA-ONT-GEZEGDE-003",
      "familyId": "TAA-ONT-GEZEGDE",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_gezegde",
      "questionType": "multiple_choice",
      "question": "Hoeveel werkwoorden bevat het gezegde in: 'De kinderen zullen morgen buiten gaan spelen.'?",
      "options": ["3", "1", "2", "4"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Werkwoorden tellen", "content": "Het gezegde bevat alle werkwoorden in de zin. 'Zullen' = PV, 'gaan' en 'spelen' = overige werkwoorden. 'Morgen' en 'buiten' zijn bijwoorden, geen werkwoorden.", "icon": "lightbulb"}}],
      "conceptId": "gezegde_tellen",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.gez-werkwoorden-tellen-fout", "label": "Aantal werkwoorden in gezegde verkeerd geteld", "optionIndex": 1 },
          { "id": "taa.gez-bijwoord-als-werkwoord", "label": "Bijwoord geteld als werkwoord", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Het gezegde bevat 3 werkwoorden: 'zullen gaan spelen'. 'Zullen' is de persoonsvorm, 'gaan' en 'spelen' zijn de andere werkwoorden.",
        "solutionSteps": [
          "PV: 'zullen' (verandert bij tijdwisseling)",
          "Overige werkwoorden: 'gaan' en 'spelen'",
          "Gezegde = 'zullen gaan spelen' = 3 werkwoorden",
          "'morgen' en 'buiten' zijn geen werkwoorden"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Zullen gaan spelen' = 3 werkwoorden.",
          "1": "Je dacht waarschijnlijk dat er maar 1 werkwoord is. Maar er zijn er 3: naast de PV 'zullen' zijn er ook 'gaan' en 'spelen'. Onthoud: tel alle werkwoorden.",
          "2": "Je dacht waarschijnlijk dat er 2 werkwoorden zijn. Maar er zijn er 3: 'zullen', 'gaan' én 'spelen' horen allemaal bij het gezegde.",
          "3": "Je dacht waarschijnlijk dat er 4 werkwoorden zijn. Maar 'morgen' en 'buiten' zijn bijwoorden, geen werkwoorden. Onthoud: een werkwoord beschrijft een handeling."
        }
      }
    },
    {
      "id": "TAA-ONT-GEZEGDE-004",
      "familyId": "TAA-ONT-GEZEGDE",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_gezegde",
      "questionType": "multiple_choice",
      "question": "Welke zin heeft een naamwoordelijk gezegde?",
      "options": ["De lucht is blauw.", "De hond rent hard.", "Zij leest een boek.", "Wij fietsen naar school."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Naamwoordelijk gezegde", "content": "Een naamwoordelijk gezegde bevat een koppelwerkwoord (zijn, worden, blijven, lijken, schijnen, heten) + een naamwoordelijk deel. Het beschrijft hoe iets IS, niet wat iets DOET.", "icon": "lightbulb"}}],
      "conceptId": "gezegde_naamwoordelijk",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.gez-werkwoordelijk-als-naamwoordelijk", "label": "Werkwoordelijk gezegde aangezien voor naamwoordelijk", "optionIndex": 1 },
          { "id": "taa.gez-koppelwerkwoord-niet-herkend", "label": "Koppelwerkwoord niet herkend", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "'De lucht is blauw' heeft een naamwoordelijk gezegde. 'Is' is een koppelwerkwoord en 'blauw' is het naamwoordelijk deel. Bij een naamwoordelijk gezegde beschrijf je hoe iets IS, niet wat iets DOET.",
        "solutionSteps": [
          "'Is' is een koppelwerkwoord (zijn, worden, blijven, lijken, schijnen, heten)",
          "'Blauw' is het naamwoordelijk deel van het gezegde",
          "Gezegde = 'is blauw' (naamwoordelijk gezegde)"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Is blauw' is een naamwoordelijk gezegde (koppelwerkwoord + naamwoordelijk deel).",
          "1": "Je dacht waarschijnlijk dat 'rent hard' naamwoordelijk is. Maar 'rent' is een werkwoordelijk gezegde — de hond DOET iets (rennen). Onthoud: naamwoordelijk = hoe iets IS.",
          "2": "Je dacht waarschijnlijk dat 'leest' naamwoordelijk is. Maar 'leest' is een werkwoordelijk gezegde — zij DOET iets (lezen). Onthoud: koppelwerkwoorden zijn: zijn, worden, blijven, lijken.",
          "3": "Je dacht waarschijnlijk dat 'fietsen' naamwoordelijk is. Maar 'fietsen' is een werkwoordelijk gezegde — wij DOEN iets (fietsen). Onthoud: naamwoordelijk gezegde = koppelwerkwoord."
        }
      }
    },
    {
      "id": "TAA-ONT-GEZEGDE-005",
      "familyId": "TAA-ONT-GEZEGDE",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_gezegde",
      "questionType": "fill_in",
      "question": "Wat is de persoonsvorm in de zin: 'Gisteren speelden de kinderen in het park.'? Typ het woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["speelden"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Persoonsvorm vinden", "content": "Verander de tijd van de zin. Het woord dat verandert is de persoonsvorm. 'Gisteren speelden...' → 'Morgen spelen...' → 'speelden' verandert, dus dat is de PV.", "icon": "lightbulb"}}],
      "conceptId": "gezegde_persoonsvorm",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 1, "misconceptionTags": [] },
      "feedback": {
        "explanationText": "'Speelden' is de persoonsvorm. Verander de tijd: 'Morgen spelen de kinderen in het park.' Het woord dat verandert (speelden → spelen) is de persoonsvorm.",
        "solutionSteps": [
          "Verander de tijd van de zin",
          "'Speelden' verandert naar 'spelen'",
          "Dus 'speelden' is de persoonsvorm"
        ]
      }
    },
    {
      "id": "TAA-ONT-GEZEGDE-006",
      "familyId": "TAA-ONT-GEZEGDE",
      "module": "Taalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "zinsontleding",
      "subSkill": "ontl_gezegde",
      "questionType": "sentence_parser",
      "question": "Wijs het onderwerp (OND) en het gezegde (GEZ) aan in deze zin.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentenceParser": {
          "sentence": "De leerlingen hebben de toets gemaakt.",
          "words": ["De leerlingen", "hebben", "de toets", "gemaakt"],
          "labels": ["OND", "GEZ", "GEZ"],
          "colors": {
            "OND": "#3B82F6",
            "GEZ": "#10B981"
          },
          "correctAssignments": {
            "0": "OND",
            "1": "GEZ",
            "3": "GEZ"
          }
        }
      },
      "conceptId": "gezegde_parser_samengesteld",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Samengesteld gezegde toewijzen",
            "content": "Het gezegde bevat ALLE werkwoorden: 'hebben' (PV) + 'gemaakt' (voltooid deelwoord). Het onderwerp is: wie hebben de toets gemaakt? → De leerlingen. 'De toets' is het lijdend voorwerp.",
            "icon": "lightbulb"
          }
        }
      ],
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Het gezegde is 'hebben gemaakt' (samengesteld: PV + voltooid deelwoord). Het onderwerp is 'De leerlingen' (wie hebben gemaakt?). 'De toets' is het lijdend voorwerp — dat hoort niet bij het gezegde.",
        "solutionSteps": [
          "Zoek de werkwoorden: 'hebben' en 'gemaakt'",
          "Beide werkwoorden horen bij het gezegde",
          "Wie hebben de toets gemaakt? → De leerlingen = onderwerp",
          "'De toets' = lijdend voorwerp (niet het gezegde)"
        ]
      }
    }
  ]
}